skrilla.controller('promotionCodeAndClaimsCtrl', function ($scope, cacheService, srefService, modalService, searchService, $stateParams) {


    $scope.codeId = $stateParams.id
    const url =  "promotions/codes/" + $scope.codeId;
    searchService.get(url).then(function (response) {
        $scope.code = response.data;
    });

    $scope.route = function(){
        var location = $scope.code.ownerType === "USER" ? "userDetails" : "affiliateDetails";
        srefService.go(location, {id: $scope.code.ownerId});
        modalService.dismissAll();
    }

    $scope.updateActive = function(){
        modalService.confirm("Are you sure you want to update this code?", function(){
            searchService.put("promotions/codes/" + $scope.code.id + "/active/" + !$scope.code.active,  {}, "Code successfully updated.").then(function () {
                $scope.code.active = !$scope.code.active;
            })
        });
    }

});
